import { render, staticRenderFns } from "./Banner_area.vue?vue&type=template&id=07447272&scoped=true&"
import script from "./Banner_area.vue?vue&type=script&lang=js&"
export * from "./Banner_area.vue?vue&type=script&lang=js&"
import style0 from "./Banner_area.vue?vue&type=style&index=0&id=07447272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07447272",
  null
  
)

export default component.exports